// Libraries
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// Actions
import {
    createEntityRequest,
    createEntityError,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';

// Constant
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import { ENTITY_TYPE } from '../../utils/constants/commonValues';

// Component
import { FormElems, Alert } from '..';
import validate from './validator';

// Validator

// Styles
import './addPartner.scss';

/**
 * AddPartner Component
 *
 * @param {Object} props - React component props
 */
const AddPartner = props => {
    const {
        closePopup,
        actions,
        handleSubmit,
        merchantData,
        staticData,
    } = props;
    const { createEntity } = merchantData;
    const { staticInfo } = staticData;

    const [showUserEmailField, setShowUserEmailField] = useState(false);

    const onCancel = (onSuccess, entityType) => {
        closePopup(onSuccess, entityType);
    };

    /* Effect is to shw the success message and reset redux error */
    useEffect(() => {
        if (createEntity.isSuccess) {
            onCancel(true, ENTITY_TYPE.AGGREGATOR);
            toast.info(SUCCESS_MESSAGES.CREATE_ENTITY('Aggregator'));
        }
        return () => {
            if (createEntity.isSuccess) {
                actions.createEntityError({ error: {} });
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createEntity.isSuccess]);

    /**
     * Method to handle form submit values for Aggregator
     *
     * @returns {object}
     */
    const handleFormSubmit = values => {
        // const request = Object.assign({}, values);
        // request.entityType = 'AGGREGATOR';
        // request.portalAccess =
        //     (values &&
        //         values.portalAccess &&
        //         Array.isArray(values.portalAccess) &&
        //         values.portalAccess.includes('portalAccess')) ||
        //     false;
        // actions.createEntityRequest(request);
    };

    return (
        <form className="add-aggregator-form">
            {createEntity.error && createEntity.error.errorMessage ? (
                <Alert customClass="error-msg">
                    {createEntity.error.errorMessage}
                </Alert>
            ) : null}
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Partner Name</p>
                    <Field
                        name="name"
                        type="text"
                        component={FormElems.Input}
                        placeholder="Enter Name"
                    />
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Email ID</p>
                    <Field
                        name="email"
                        type="text"
                        component={FormElems.Input}
                        placeholder="Enter Email ID"
                    />
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Phone Number</p>
                    <Field
                        name="phoneNo"
                        type="text"
                        component={FormElems.Input}
                        placeholder="Enter Phone Number"
                    />
                </div>
            </div>
            <div className="form-section action">
                <FormElems.Button
                    buttonType="secondary"
                    text="CANCEL"
                    type="button"
                    id="cancel-button"
                    handleClick={onCancel}
                />
                <FormElems.Button
                    buttonType="primary"
                    text="SUBMIT"
                    id="submit-button"
                    handleClick={handleSubmit(handleFormSubmit)}
                />
            </div>
        </form>
    );
};

const mapStateToProps = ({ auth, form, merchantData, staticData }) => ({
    auth,
    form,
    staticData,
    merchantData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            createEntityRequest,
            createEntityError,
        },
        dispatch,
    ),
});

AddPartner.propTypes = {
    actions: PropTypes.object,
    actionType: PropTypes.string,
    auth: PropTypes.object,
    closePopup: PropTypes.func,
    data: PropTypes.object,
    form: PropTypes.object,
    handleSubmit: PropTypes.func,
    merchantData: PropTypes.object,
    staticData: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'add-aggregator-form',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(AddPartner);
